import { CdkMenu, CdkMenuItem } from '@angular/cdk/menu';
import { NgClass } from '@angular/common';
import { Component, input } from '@angular/core';
import { UIBasicIconsType, UseUIBasicIconDirective } from '../atoms';

export interface DropdownMenuOption {
  type?: string;
  label: string;
  icon?: UIBasicIconsType;
  action?: (() => void) | undefined;
  disabled?: boolean;
  error?: boolean;
  active?: boolean;
  separator?: boolean;
}

@Component({
  selector: 'dmcom-dropdown-menu',
  standalone: true,
  imports: [NgClass, UseUIBasicIconDirective, CdkMenu, CdkMenuItem],
  template: `
    <div
      cdkMenu
      class="flex flex-col w-fit bg-dropdown-main rounded border border-stroke-neutral overflow-y-auto"
      style="background-color: var(--color-shades-white); height: 180px;"
    >
      @for (option of options(); track option.label; let first = $first) {
        <button
          cdkMenuItem
          class="
            flex flex-row gap-16 items-center
            px-24 py-6 w-full
            font-main-text text-paragraphs
            cursor-pointer
            hover:bg-dropdown-option-hovered active:bg-dropdown-option-selected [&.active]:bg-dropdown-option-selected
            focus:outline-none focus:bg-dropdown-option-selected
            disabled:text-disabled disabled:cursor-not-allowed disabled:bg-dropdown-option-disabled
            [&>svg]:size-24
          "
          [class.mt-16]="first"
          style="background-color: var(--color-shades-white); font-size: 14px; color: var(--color-neutral-50);"
          [ngClass]="{
            'text-error border border-dropdown-stroke-error': option.error,
            'border-t border-stroke-neutral': option.separator,
            active: option.active,
          }"
          [disabled]="option.disabled"
          (click)="option.action ? option.action() : null"
        >
          @if (option.icon) {
            <svg
              [dmcomUseUIBasicIcon]="option.icon!"
              [class.text-icon-neutral-enabled]="!option.error && !option.disabled"
              [class.text-icon-error-enabled]="option.error"
              [class.text-icon-neutral-disabled]="option.disabled"
            ></svg>
          }
          <span class="flex-1 max-w-full whitespace-nowrap overflow-hidden text-ellipsis text-left">{{ option.label }}</span>
        </button>
      }
    </div>
  `,
  styles: [
    `
      ::-webkit-scrollbar {
        width: 8px;
      }

      ::-webkit-scrollbar-track {
        background: transparent;
      }

      ::-webkit-scrollbar-thumb {
        background: var(--color-neutral-500);
        border-radius: 4px;
      }
    `,
  ],
})
export class DropdownMenuComponent {
  public readonly options = input.required<DropdownMenuOption[]>();
}
